/** TODO FILE */

import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import styled from 'styled-components';

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 100%;
  row-gap: 5vh;
`;

export const TableSettingContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const ItemContainer = styled.div`
  display: flex;
  gap: 30px;
  border: 1px solid black;
`;

export const ItemContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const HeaderLeftItems = styled.div`
  display: flex;
  justify-content: space-between;

  align-items: center;
  gap: 10px;
  flex-basis: 60%;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const HeaderLeftFirstItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const HeaderLeftSecondItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-basis: 70%;
`;

export const HeaderRightItems = styled.div`
  display: flex;

  align-items: center;
  gap: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: flex-end;
  }
`;

export const FileUploadWrapper = styled.div`
  display: 'flex';
  background: #f3f4f8;
  display: flex;
  align-self: center;
  border-radius: 10px;
`;

export const FileUploadWrapperRemove = styled.div`
  display: flex;
  align-self: center;
  padding-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const TrashIcon = styled(FiIcons.FiTrash2)`
  pointer-events: none;
`;

export const InputLabel = styled.div`
  color: '#222247';
`;

export const Input = styled.input`
  display: block;
  height: 35px;
  font-size: 1.4rem;
  color: #222247;

  border-radius: 7px;
  padding: 0 8px;
  border: 1px solid #dbdbdc;
  &:disabled {
    border: 1px solid transparent;
  }
`;

export const StyledErrorWrap = styled.p`
  font-size: 12px;
  font-weight: 400;
  padding: 0 16px;
  color: red;
`;

export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
`;

export const GalleryHeader = styled.p`
  margin: 0;
  text-align: left;
  font: normal normal normal 20px/30px Biotif;
`;

export const EmptyGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

type GalleryCardImgType = { selected?: boolean };

export const GalleryCardImg = styled.div<GalleryCardImgType>`
  display: flex;
  flex-grow: 2;
  width: 140px;
  max-width: 140px;
  height: 113px;
  border-radius: 4px 4px 0 0;
  justify-content: flex-end;
  margin: 2px;

  border: ${props => (props.selected ? '3px solid #2DCAFC' : '')};
  background-position: center;
  background-size: cover;
`;

export const FallbackImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const GalleryScrollableContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  max-height: 300px;
  gap: 20px;
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
